import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'send-iframe-ready';
export function useSendIframeReady() {
    const { postMessage } = useIframeMessageContext();
    const sendIframeReady = useCallback(() => {
        postMessage(MESSAGE_TYPE, {});
    }, [postMessage]);
    return { sendIframeReady };
}
const handleMessage = (context, message) => {
    const { setIframeReady } = context;
    // console.log('set iframe ready setIframeReady()');
    setIframeReady(true);
};
registerIframeMessageHook(MESSAGE_TYPE, useSendIframeReady, handleMessage);
//# sourceMappingURL=useSendIframeReady.js.map